module.exports = __webpack_public_path__ + "static/media/ic_wallet_b4_fisdom.de993008.svg";